import React from "react";
import "./index.scss";
import { SvgIcon } from "yds-svg-icon";

type IProps = {
  title: string;
  onClose?: () => void;
};

export function Header(props: IProps) {
  const { title, onClose: onHandleClose } = props;
  return (
    <div className="ModalHeader">
      <span>{title}</span>
      <SvgIcon
        className="ModalHeader-close"
        type="Close"
        onClick={onHandleClose}
      />
    </div>
  );
}
